<script>
 // 设置全局 登录URL
  const BASE_LOGIN_URL = 'https://dhapi.library.sh.cn/management/webapi/cenofmagent/token/locpage?systemId=18&durl='; 
  const BASE_IP_INFO = ''; //用户IP chenss 20220831
  export default{
    BASE_LOGIN_URL,
    BASE_IP_INFO//用户IP chenss 20220831
  }
</script>